module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"submit":"Update"}}')
  delete Component.options._Ctor
}
